/* eslint-disable */ 
WB.Utility = WB.Utility || {};

WB.Utility.Data = function ($http, $location, $q, HtmlUtility, _Config)
{
    

    let gtmPageTitlesMap;
    const prevPageMap = new Map();
    var $head = document.querySelector('head');

    var removeMeta = function (name, type)
    {
        type = type || 'name';
        var querySelector = 'meta[' + type + '="' + name.replace(/\:/g, '\:') + '"]';
        removeHeaderItem(querySelector);
    };

    var removeCanonical = function(name,type)
    {
        type = type || 'name';
        var querySelector = 'link[' + type + '="' + name.replace(/\:/g, '\:') + '"]';
        removeHeaderItem(querySelector);
    };

    var removeHeaderItem = function(querySelector)
    {
        var headerItems = $head.querySelectorAll(querySelector);
        if (headerItems !== null)
        {
            headerItems.forEach(function(headerItem)
            {
                $head.removeChild(headerItem);
            });
        }
    };

    var updateMeta = function (name, content, type)
    {
        type = type || 'name';
        removeMeta(name, type);

        if (content !== null)
        {
            var $newMeta = document.createElement('meta');
            $newMeta.setAttribute(type, name);
            $newMeta.setAttribute('content', HtmlUtility.encode(content));

            $head.appendChild($newMeta);
        }
    };

    const updateMetaRaw = (name, content, type = 'name') => {
        removeMeta(name, type);
    
        if (content) {
            const $newMeta = document.createElement('meta');
            $newMeta.setAttribute(type, name);
            $newMeta.setAttribute('content', content);
            $head.appendChild($newMeta);
        }
    };

    var updateCanonicalTag = function (name, content, type)
    {
        type = type || 'name';
        removeCanonical(name,type);
        if (content !== null && content!=='')
        {
            var $newMeta = document.createElement('link');
            $newMeta.setAttribute(type, name);
            $newMeta.setAttribute('href', HtmlUtility.encode(content));
            $head.appendChild($newMeta);
        }
    };

    const listenForGTMDataLayerEvent = function(eventName, callback) {
        window.dataLayer = window.dataLayer || [];

        const originalPush = window.dataLayer.push;
        window.dataLayer.push = function() {
            originalPush.apply(this, arguments);
            
            const eventObj = arguments[0];

            if (typeof eventObj === 'object' && eventObj?.event === eventName) {
                callback(eventObj)
            }
        }
    }

    var _this = this;

    this.Data = null;

    this.get = function ()
    {
        return this.Data;
    };

    this.set = function (metadata)
    {
        this.Data = metadata;

        if (this.Data.Meta)
        {
            this.title(this.Data.Meta.Title);
            this.description(this.Data.Meta.Description);
            this.keywords(this.Data.Meta.Keywords);
            this.robots(this.Data.Meta.Robots);

            // Initialize the social or set as empty
            this.Data.Meta.Social = this.Data.Meta.Social || {
                Title: null,
                Description: null,
                Image: null,
                Url: null,
                CardType: 'summary',
                PageType: 'website',
                LastModifiedDate: null,
                PublishedDate: null,
            };

            this.Social.title(this.Data.Meta.Social.Title);
            this.Social.description(this.Data.Meta.Social.Description);
            this.Social.image(this.Data.Meta.Social.Image);
            this.Social.url(this.Data.Meta.Canonical);
            this.Social.cardType(this.Data.Meta.Social.CardType);
            this.Social.pageType(this.Data.Meta.Social.PageType);
            this.Social.lastModifiedDate(this.Data.Meta.Social.LastModifiedDate);
            this.Social.publishedDate(this.Data.Meta.Social.PublishedDate);

            this.canonical(this.Data.Meta.Canonical);

            this.robots(this.Data.Meta.Robots);
        }
    };

    this.clear = function ()
    {
        this.Data = { Meta: { Social: {} } };
    };

    this.title = function (title)
    {
        const gtmPageViewEventName = 'setPageTitleEvent';
        if (typeof (title) !== 'undefined')
        {
            this.Data.Meta.Title = title;

            var _title = 'WeatherBug';
            if (title != null && title.length > 0)
            {
                _title = title + ' | ' + _title;
            }
        
            const pageCanonicalUrl = this.Data?.Meta?.Canonical;
        
            const isPageTitleHandledByGTM = _Config?.GoogleTagManager?.PagesWithGTMTitleTags?.some(pagePathWithGTMTitleTag => pageCanonicalUrl?.includes(pagePathWithGTMTitleTag));
            
            if (isPageTitleHandledByGTM && _Config?.GoogleTagManager?.IsEnabled) {
                // Grab the title from the main website document. 
                const titleElement = document.querySelector('head > title');

                // A K/V pair of all titles set via GTM for a given canonical URL, granted the PageView event on GTM is only fired once.
                // We are preventing title tag set via GTM from being overridden by Client side code, 
                // this creates another problem, where navigating to different pages and revisiting the page whose title tag was previously set via GTM doesn't get the 
                // correct page title as the GTM Page View event isn't fired again.
                gtmPageTitlesMap = !gtmPageTitlesMap ? new Map() : gtmPageTitlesMap;

                // Previous title tag data:
                let lastItemInPrevPageMap = prevPageMap ? Array.from(prevPageMap)[prevPageMap.size-1] : [];

                const gtmPageTitle = gtmPageTitlesMap?.get(pageCanonicalUrl);

                if (pageCanonicalUrl && gtmPageTitle && titleElement.textContent !== gtmPageTitle) {
                    document.title = gtmPageTitle;
                } else if (lastItemInPrevPageMap?.[0] && lastItemInPrevPageMap?.[0] !== pageCanonicalUrl) {
                    document.title = _title;
                }

                // Tech-debt:
                // Let's revisit this approach so we don't have to handle most of this on client side code and instead do all these stuff on GTM.
                // We could set the GTM tag to fire with each history change 
                // (i.e. any time Ajax is fired when a page changes and there is a push state change to the URL)
                // but this isn't neccesary for our objective of Googlebot crawling and indexing the updated title tags, but it's more of a UX problem.
                listenForGTMDataLayerEvent(gtmPageViewEventName, (event) => {
                    const pageTitleFromEvent = event?.gtmPageTitle;
                    if (pageTitleFromEvent) {
                        // Title tag has been set via GTM so let's save to Map
                        gtmPageTitlesMap?.set(pageCanonicalUrl, pageTitleFromEvent);
                    } else {
                        document.title = _title; // fallback to default behaviour
                    }
                });

            } else {
                document.title = _title;
            }
            prevPageMap.set(this.Data?.Meta?.Canonical, _title);
        }

        return this.Data.Meta.Title;
    };

    this.description = function (description)
    {
        if (typeof (description) !== 'undefined')
        {
            this.Data.Meta.Description = description;

            updateMetaRaw('description', this.Data.Meta.Description);
        }
        else
        {
            removeMeta(name, 'name');
        }

        return this.Data.Meta.Description;
    };

    this.keywords = function (keywords)
    {
        if (typeof (keywords) !== 'undefined')
        {
            this.Data.Meta.Keywords = keywords;

            updateMetaRaw('keywords', this.Data.Meta.Keywords);
        }
        else
        {
            removeMeta(name, 'name');
        }

        return this.Data.Meta.Keywords;
    };

    this.Social = {

        title: function (title)
        {
            if (typeof (title) !== 'undefined')
            {
                _this.Data.Meta.Social = _this.Data.Meta.Social || {};
                _this.Data.Meta.Social.Title = title;

                var _title='WeatherBug';
                if (title != null && title.length > 0)
                {
                    _title = title + ' | ' + _title;
                }

                updateMetaRaw('og:title', _title, 'property');
                updateMetaRaw('twitter:title', _title, 'name');
            }
            else
            {
                removeMeta('og:title', 'property');
                removeMeta('twitter:title', 'name');
            }

            return _this.Data.Meta.Social.Title;
        },

        description: function (description)
        {
            if (typeof (description) !== 'undefined')
            {
                _this.Data.Meta.Social = _this.Data.Meta.Social || {};
                _this.Data.Meta.Social.Description = description;

                updateMetaRaw('og:description', _this.Data.Meta.Social.Description, 'property');
                updateMetaRaw('twitter:description', _this.Data.Meta.Social.Description, 'name');
                updateMetaRaw('og:image:alt', _this.Data.Meta.Social.Description, 'property');
            }
            else
            {
                removeMeta('og:description', 'property');
                removeMeta('twitter:description', 'name');
                removeMeta('og:image:alt', 'property');
            }

            return _this.Data.Meta.Social.Description;
        },

        image: function (image)
        {
            if (typeof (image) !== 'undefined')
            {
                _this.Data.Meta.Social = _this.Data.Meta.Social || {};
                _this.Data.Meta.Social.Image = image;

                updateMeta('og:image', _this.Data.Meta.Social.Image, 'property');
                updateMeta('og:image:secure_url', _this.Data.Meta.Social.Image, 'property');
                updateMeta('twitter:image', _this.Data.Meta.Social.Image, 'name');
            }
            else
            {
                removeMeta('og:image', 'property');
                removeMeta('og:image:secure_url', 'property');
                removeMeta('twitter:image', 'name');
            }

            return _this.Data.Meta.Social.Image;
        },

        url: function (url)
        {
            if (typeof (url) !== 'undefined')
            {
                _this.Data.Meta.Social = _this.Data.Meta.Social || {};
                _this.Data.Meta.Social.Url = url;

                updateMeta('og:url', _this.Data.Meta.Social.Url, 'property');
                updateMeta('twitter:url', _this.Data.Meta.Social.Url, 'name');
            }
            else
            {
                removeMeta('og:url', 'property');
                removeMeta('twitter:url', 'name');
            }

            return _this.Data.Meta.Social.Url;
        },

        cardType: function (cardType)
        {
            if (typeof (cardType) !== 'undefined')
            {
                _this.Data.Meta.Social = _this.Data.Meta.Social || {};
                _this.Data.Meta.Social.CardType = cardType;

                updateMeta('twitter:card', _this.Data.Meta.Social.CardType, 'name');
            }
            else
            {
                removeMeta('twitter:card', 'name');
            }

            return _this.Data.Meta.Social.CardType;
        },

        pageType: function (pageType)
        {
            if (typeof (pageType) !== 'undefined')
            {
                _this.Data.Meta.Social = _this.Data.Meta.Social || {};
                _this.Data.Meta.Social.PageType = pageType;

                updateMeta('og:type', _this.Data.Meta.Social.PageType, 'property');
            }
            else
            {
                removeMeta('og:type', 'property');
            }

            return _this.Data.Meta.Social.PageType;
        },

        lastModifiedDate: function (lastModifiedDate)
        {
            if (typeof (lastModifiedDate) !== 'undefined')
            {
                _this.Data.Meta.Social = _this.Data.Meta.Social || {};
                _this.Data.Meta.Social.LastModifiedDate = lastModifiedDate;

                if (_this.Data.Meta.Social.PageType === 'article')
                {
                    updateMeta('article:expiration_time', _this.Data.Meta.Social.LastModifiedDate, 'property');
                }
                else if (_this.Data.Meta.Social.PageType === 'video.other')
                {
                    removeMeta('article:modified_time', 'property');
                }
            }
            else
            {
                removeMeta('article:modified_time', 'property');
            }

            return _this.Data.Meta.Social.LastModifiedDate;
        },

        publishedDate: function (publishedDate)
        {
            if (typeof (publishedDate) !== 'undefined')
            {
                _this.Data.Meta.Social = _this.Data.Meta.Social || {};
                _this.Data.Meta.Social.PublishedDate = publishedDate;

                if (_this.Data.Meta.Social.PageType === 'article')
                {
                    updateMeta('article:published_time', _this.Data.Meta.Social.PublishedDate, 'property');
                    removeMeta('video:release_date', 'property');
                }
                else if (_this.Data.Meta.Social.PageType === 'video.other')
                {
                    removeMeta('article:published_time', 'property');
                    updateMeta('video:release_date', _this.Data.Meta.Social.PublishedDate, 'property');
                    removeMeta('article:modified_time', 'property');
                }
                else
                {
                    removeMeta('article:published_time', 'property');
                    removeMeta('video:release_date', 'property');
                }
            }
            else
            {
                removeMeta('article:published_time', 'property');
                removeMeta('video:release_date', 'property');
            }

            return _this.Data.Meta.Social.PublishedDate;
        }

    };

    this.canonical = function (canonical)
    {
        if (typeof (canonical) !== 'undefined')
        {
            this.Data.Meta.Canonical = canonical;

            updateCanonicalTag('canonical', this.Data.Meta.Canonical, 'rel');
        }
        else
        {
            removeMeta('canonical', 'rel');
        }

        return this.Data.Meta.Canonical;
    };

    this.robots = function (robots)
    {
        if (typeof (robots) !== 'undefined')
        {
            this.Data.Meta.Robots = robots;

            if (_Config?.Environtment?.toLowerCase() === 'production') {
                updateMeta('robots', this.Data.Meta.Robots);
            }
        }
        else
        {
            if (_Config?.Environtment?.toLowerCase() === 'production') {
                removeMeta('robots', 'name');
            }
        }

        return this.Data.Meta.Robots;
    };
};

WB.Utility.Data.$inject = ['$http', '$location', '$q', 'HtmlUtility', '_Config'];

WB.Core.service('Metadata', WB.Utility.Data);
